import React, { useState } from 'react';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { getAllProperties } from 'src/redux/properties/thunks';
import { getAllTypekeys } from 'src/redux/typekeys/thunks';
import { getAllDrawersDivisions } from 'src/redux/drawersdivisions/thunks';

const SearchProperty = ({ onComplete, onChangeInputValue }: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [property, setProperty] = useState<any>(null);
  const [showIsNotFound, setShowIsNotFound] = useState(false);

  const dispatch = useDispatch<any>();

  const formik = useFormik({
    initialValues: {
      nid: '',
    },
    onSubmit: (values) => {
      handleFilterProperty(values.nid);
    },
  });

  const handleFilterProperty = async (propertyNid: string) => {
    const filter = `&nid=${propertyNid}`;
    setIsLoading(true);
    setProperty(null);
    setShowIsNotFound(false);

    try {
      const data = await dispatch(getAllProperties({ filter, pagination: {} }));

      if (!data.payload.properties.length) {
        setShowIsNotFound(true);
        return;
      }

      dispatch(getAllTypekeys(''));
      dispatch(getAllDrawersDivisions(''));
      setProperty(data.payload.properties[0]);
      onComplete();
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form className='mt-8' onSubmit={formik.handleSubmit}>
      <label
        htmlFor='default-search'
        className='text-base font-medium text-gray-900 darkNot:text-white'
      >
        Ingresa El NID de la propiedad{' '}
      </label>
      <div className='relative mt-0.5'>
        <div className='absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none'>
          <svg
            aria-hidden='true'
            className='w-5 h-5 text-gray-500 darkNot:text-gray-400'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
            />
          </svg>
        </div>
        <input
          onChange={(e) => {
            onChangeInputValue();
            formik.handleChange(e);
          }}
          disabled={isLoading}
          name='nid'
          type='search'
          autoComplete='off'
          id='nid'
          className='block border border-gray-200 disabled:bg-gray-200 disabled:border-gray-400 w-full p-4 pl-10 text-gray-900 rounded-lg bg-gray-50 focus:outline focus:ring-purple-500 focus:border-purple-500 darkNot:bg-gray-700 darkNot:border-gray-600 darkNot:placeholder-gray-400 darkNot:text-white darkNot:focus:ring-purple-500 darkNot:focus:border-purple-500'
          placeholder='1234'
          required
        />
        <button
          type='submit'
          className='text-white flex items-center justify-center absolute right-2.5 bottom-2 bg-purple-600 focus:outline-none font-medium rounded-lg text-sm px-4 py-2 darkNot:bg-purple-600 darkNot:hover:bg-purple-700 darkNot:focus:ring-purple-800'
        >
          <span>Buscar</span>
          {isLoading && (
            <div
              role='status'
              className=' ml-2 flex items-center justify-center'
            >
              <svg
                aria-hidden='true'
                className='inline w-5 h-5 text-white animate-spin darkNot:text-gray-600 fill-gray-700 darkNot:fill-gray-300'
                viewBox='0 0 100 101'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
                  fill='currentColor'
                />
                <path
                  d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
                  fill='currentFill'
                />
              </svg>
              <span className='sr-only'>Loading...</span>
            </div>
          )}
        </button>
      </div>

      {showIsNotFound && (
        <section className='flex items-center h-full sm:p-4 darkNot:bg-gray-900 darkNot:text-gray-100'>
          <div className='container flex flex-col items-center justify-center px-5 mx-auto  space-y-2 text-center sm:max-w-md'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth={1.5}
              stroke='currentColor'
              className='w-16 h-16'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25'
              />
            </svg>

            <div>
              <p className='text-3xl'>No existe el NID</p>
              <p className='text-base'>Intentalo nuevamente</p>
            </div>
          </div>
        </section>
      )}

      {property && (
        <section className='mt-3 flex items-center mx-auto space-y-2 sm:max-w-md'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth={1.5}
            stroke='currentColor'
            className='w-16 h-16'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25'
            />
          </svg>

          <div className='ml-4'>
            <p className='text-3xl'>NID: {property.nid}</p>
            <ul className='list-disc pl-4 mt-2'>
              <li>Dirección: {property.address}</li>
              <li>
                Cantidad de llaves:{' '}
                <span className='px-4 p-0.5 rounded-3xl bg-blue-500 text-white text-sm'>
                  {property.keys.length}
                </span>
              </li>
            </ul>
          </div>
        </section>
      )}
    </form>
  );
};

export default SearchProperty;
